import { EditedBannerCreative } from './bannersEditState';
import { EditorPlaceId } from './common';

export type CreativeState = Record<EditorPlaceId, EditedBannerCreative>;

export enum CreativeType {
    GdSmartCreative = 'GdSmartCreative',
    GdCpcVideoCreative = 'GdCpcVideoCreative',
    GdCpmAudioCreative = 'GdCpmAudioCreative',
    GdCpmGeoproductCreative = 'GdCpmGeoproductCreative',
    GdCpmIndoorCreative = 'GdCpmIndoorCreative',
    GdCpmOutdoorCreative = 'GdCpmOutdoorCreative',
    GdCpmVideoCreative = 'GdCpmVideoCreative',
    GdHtml5Creative = 'GdHtml5Creative',
    GdVideoAdditionCreative = 'GdVideoAdditionCreative'
}
